export class ConsoleLoginCheck {
  url: string;
  payload: any;
}
